window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.Sliders = (function Sliders() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $slider = document.querySelector('.slider-wrapper');
    const $sliderProjects = document.querySelector('.slider-projects-wrapper');
    const $sliderValues = document.querySelector('.values-slides-wrapper');
    const $sliderAdvantages = document.querySelector('.slider-advantages-wrapper');
    const $sliderClients = document.querySelector('.slider-clients');

    if ($slider) {
      new Flickity( $slider, {
        // options
        cellAlign: 'left',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 3500
      } );
    }

    if  ($sliderClients) {
      new Flickity( $sliderClients, {
        // options
        cellAlign: 'center',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 1500
      } );
    }

    if ($sliderProjects) {
      new Flickity( $sliderProjects, {
        // options
        cellAlign: 'center',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: false,
      } );
    }

    if ($sliderAdvantages) {
      new Flickity( $sliderAdvantages, {
        // options
        cellAlign: 'center',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: false,
      } );
    }

    if ($sliderValues) {
      new Flickity( $sliderValues, {
        // options
        cellAlign: 'left',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: false
      } );
    }
    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
